import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Actividades/actividades';
import ActividadesGrid from './ActividadesGrid';

const mstp = state => {
    return {...state.actividades ,permisos: state.login.me.permisos, }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ActividadesGrid)


